import React, { useEffect, useState } from "react";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { Link } from "react-router-dom";
import { useBackground } from "../context/BackgroundContext";

function CatalogDropdowns() {
  const [catalogs, setCatalogs] = useState([]);
  const { theme } = useBackground();

  const db = getFirestore();

  useEffect(() => {
    const fetchCatalogs = async () => {
      const snapshot = await getDocs(collection(db, "catalogs"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCatalogs(data);
    };
    fetchCatalogs();
  }, [db]);

  return (
    <li className="nav-item dropdown d-md-block d-lg-flex">
      {catalogs.map((catalog) => (
        <React.Fragment key={catalog.id}>
          <div
            className="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ color: theme.text }}
          >
            {catalog.catalogName}
          </div>
          <ul className="dropdown-menu">
            {catalog.collections.map((col) => (
              <Link
                key={col}
                className="dropdown-item text-decoration-none"
                to={`/catalog/${catalog.catalogName}/${col}`}
                style={{ color: theme.textSecondary }}
              >
                {col}
              </Link>
            ))}
          </ul>
        </React.Fragment>
      ))}
    </li>
  );
}

export default CatalogDropdowns;
